import {
  DELETE_TOKEN,
  DELETE_LIST_POINT_OF_SALES,
} from "@/constants/mutations-type";
import { MODEL_DESIGNER } from "@/constants/states";
import { SET_DESIGNER_MODEL } from "@/constants/mutations-type";
import router from "@/router";
export default {
  logout: async ({ commit }) => {
    commit(DELETE_TOKEN);
    commit("designer/" + SET_DESIGNER_MODEL, MODEL_DESIGNER, {root: true})
    commit("designer/" + DELETE_LIST_POINT_OF_SALES, null, { root: true });
    router.push("/#login");
  },
};
